import React from "react";

import { HTTP_STATUS_CODE } from "@constants/api.response.code";

import WaveProBrandLogo from "@components/WaveProBrandLogo";

import WPLanguageDropDown from "@common/components/WPLanguageDropDown/WPLanguageDropDown";
import Footer from "@common/footer";

import "./WPHeaderFooterPage.scss";

const WPHeaderFooterPage = ({ children, setTermsLanguage, status }) => (
  <div className='header-footer-page-container'>
    <div className='brand-logo-container'>
      <div className='app-max-width mx-auto w-100 maintenance-language-dropdown'>
        <WaveProBrandLogo />
        {(status === HTTP_STATUS_CODE.SERVICE_UNAVAILABLE || setTermsLanguage) && (
          <WPLanguageDropDown className='maintenance-language-dropdown-width' setTermsLanguage={setTermsLanguage} />
        )}
      </div>
    </div>
    <div className='p-32 w-100'>
      <div className='main-content app-max-width'>{children}</div>
    </div>
    <Footer />
  </div>
);

export default WPHeaderFooterPage;
